<template>
  <div>
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <v-dialog v-model="loader" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando Bitácora...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowing" max-width="700px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Seguimiento</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="numeroAsistencia"
                  label="NÚMERO DE ASISTENCIA"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="bitacora.operador"
                  label="OPERADOR"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="asistencia.fechaHoraActual"
                  label="FECHA APERTURA"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field
                  v-model="asistencia.comDireccionSiniestro"
                  label="DIRECCIÓN"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="asistencia.tipoServicio"
                  label="TIPO SERVICIO"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="asistencia.proveedor"
                  label="PROVEEDOR ASIGNADO"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="bitacora.atiende"
                  label="ATIENDE"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="asistencia.fechaHoraAsignacion"
                  label="FECHA ASIGNACIÓN"
                  :disabled="disabled"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col v-if="enableLegacySupport" cols="12">
                <v-col
                  cols="12"
                  v-for="(item, i) in seguimientosSeparados"
                  :key="'seguimiento-' + i"
                >
                  <v-textarea
                    v-model="item.seguimiento"
                    label="SEGUIMIENTO"
                    :readonly="item.disabled"
                    @input="ajustarAlturaIndividual($event)"
                    @focus="ajustarAlturaIndividual($event)"
                    @keyup.enter="asignarfecha(i)"
                    hint="PRESIONE ENTER PARA ASIGNAR FECHA Y SU NOMBRE"
                    auto-grow
                    :rules="rules"
                    :disabled="disabled && item.disabled"
                    outlined
                    counter="4000"
                    persistent-hint
                  ></v-textarea>
                </v-col>
              </v-col>
              <v-tabs
                v-if="
                  (seguimientosClientes.length > 0 ||
                    seguimientosProveedores.length > 0) &&
                  !enableLegacySupport
                "
                v-model="tabBitacora"
                grow
                dark
                background-color="primary"
              >
                <v-tab value="Clientes">
                  Bitácora Asegurado ({{ seguimientosClientes.length }})</v-tab
                >
                <v-tab value="Proveedores"
                  >Bitácora Proveedor ({{
                    seguimientosProveedores.length
                  }})</v-tab
                >
              </v-tabs>
              <v-tabs-items v-model="tabBitacora" wid style="width: 100%">
                <!-- Tab Clientes -->
                <v-tab-item>
                  <v-row>
                    <v-col
                      cols="12"
                      v-for="(item, i) in seguimientosClientes"
                      :key="'cliente-' + i"
                    >
                      <v-textarea
                        v-model="
                          seguimientosSeparados[item.originalIndex].seguimiento
                        "
                        label="SEGUIMIENTO"
                        :readonly="item.disabled"
                        @input="ajustarAlturaIndividual($event)"
                        @focus="ajustarAlturaIndividual($event)"
                        @keyup.enter="asignarfecha(item.originalIndex)"
                        hint="PRESIONE ENTER PARA ASIGNAR FECHA Y SU NOMBRE"
                        auto-grow
                        :rules="rules"
                        :disabled="disabled && item.disabled"
                        outlined
                        counter="4000"
                        persistent-hint
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <!-- Tab Proveedores -->
                <v-tab-item>
                  <v-col
                    cols="12"
                    v-for="(item, i) in seguimientosProveedores"
                    :key="'proveedores-' + i"
                  >
                    <v-textarea
                      v-model="
                        seguimientosSeparados[item.originalIndex].seguimiento
                      "
                      label="SEGUIMIENTO"
                      :readonly="item.disabled"
                      @input="ajustarAlturaIndividual($event)"
                      @focus="ajustarAlturaIndividual($event)"
                      @keyup.enter="asignarfecha(item.originalIndex)"
                      hint="PRESIONE ENTER PARA ASIGNAR FECHA Y SU NOMBRE"
                      auto-grow
                      :rules="rules"
                      :disabled="disabled && item.disabled"
                      outlined
                      counter="4000"
                      persistent-hint
                    ></v-textarea> </v-col
                ></v-tab-item>
              </v-tabs-items>

              <v-col cols="5">
                <v-btn
                  color="primary"
                  class="my-auto"
                  :disabled="noAgregar || disableAgregarCampo"
                  @click="agregarCampo"
                >
                  Agregar nuevo campo
                </v-btn>
              </v-col>
              <v-col cols="3" v-if="seguimientosSeparados.length == 0">
                <v-select
                  v-model="tipoDetalleBitacoraId"
                  :items="tipoDetalleBitacora"
                  label="Tipo Bitácora"
                  item-value="tipoDetalleBitacoraId"
                  item-text="nombre"
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            :disabled="disabledActualizarBitacora"
            @click="guardar"
            >GUARDAR</v-btn
          >
          <v-btn color="grey" @click="close">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "MiniBitacora",
  props: {
    numeroAsistencia: {
      type: String,
      required: true,
    },
    // Estado de Visibilidad del Componente
    isShowing: {
      type: Boolean,
      default: false,
    },
    noAgregar: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    snack: false,
    tabBitacora: null,
    tipoDetalleBitacora: [],
    tipoDetalleBitacoraId: 1,
    caracteresDisponibles: 6000,
    snackColor: "primary",
    snackTime: 4500,
    snackText: "Error",
    loader: false,
    peticionPendiente: false,
    informacionBitacora: [],
    seguimientosSeparados: [],
    detalleBitacoraToSeguimiento: [],
    seguimientoFechaUsuario: "",
    seguimiento: "",
    enableLegacySupport: true,
    asistencia: [],
    bitacora: [],
    disabledActualizarBitacora: true,
    banderaFechaNombreBitacora: false,
    rules: [(v) => v.length <= 6000 || "Máximo de Caracteres 6000"],
  }),
  created() {
    this.listarComboBox();
    this.listarBitacoras();
  },
  watch: {
    isShowing(val) {
      if (val) {
        this.loader = true;
        this.listarBitacoras();
      }
    },
  },
  computed: {
    seguimientosClientes() {
      return this.seguimientosSeparados
        .map((item, index) => ({ ...item, originalIndex: index }))
        .filter((item) => item.tipoDetalleBitacoraId === 1);
    },
    seguimientosProveedores() {
      return this.seguimientosSeparados
        .map((item, index) => ({ ...item, originalIndex: index }))
        .filter(
          (item) =>
            item.tipoDetalleBitacoraId === 2 ||
            item.tipoDetalleBitacoraId == null
        );
    },
    disableAgregarCampo() {
      return !this.enableLegacySupport &&
        this.bitacora.detalleBitacora.length < this.seguimientosSeparados.length
        ? true
        : false;
    },
  },
  methods: {
    ajustarAlturaIndividual(event) {
      const ta = event.target;
      ta.style.height = "auto";
      ta.style.height = ta.scrollHeight + "px";
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoDetalleBitacora", configuracion)
        .then((res) => (this.tipoDetalleBitacora = res.data))
        .catch((err) => console.error(err));
    },
    close() {
      this.$emit("update:isShowing", false);
      this.selectedTab = null;
      this.tabBitacora = null;
      this.tipoDetalleBitacoraId = 1;
    },
    asignarfecha(i) {
      if (this.banderaFechaNombreBitacora) {
        this.banderaFechaNombreBitacora = false;

        this.seguimientoFechaUsuario =
          this.getFechaHora() + " " + this.$store.state.usuario.nombre;
        this.seguimiento = (
          this.seguimiento +
          " " +
          this.seguimientoFechaUsuario
        ).trim();

        this.seguimientosSeparados[i].seguimiento =
          this.seguimientosSeparados[i].seguimiento + this.seguimiento;
        this.disabledActualizarBitacora = false;
      }
    },
    agregarCampo() {
      this.banderaFechaNombreBitacora = true;
      this.seguimiento = "";

      let selectedTab = this.tabBitacora;
      let tipo =
        this.seguimientosSeparados.length == 0
          ? this.tipoDetalleBitacoraId
          : selectedTab + 1;
      if (this.seguimientosSeparados.length == 0) {
        this.tabBitacora = this.tipoDetalleBitacoraId - 1;
      }

      this.seguimientosSeparados.push({
        seguimiento: "",
        disabled: false,
        tipoDetalleBitacoraId: tipo,
      });
    },
    getFechaHora() {
      let today = new Date();
      let fecha =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      return fecha;
    },
    guardar() {
      if (this.enableLegacySupport) {
        this.actualizarBitacora();
      } else {
        this.actualizarBitacoraNew();
      }
    },
    actualizarBitacoraNew() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.peticionPendiente) return;

      this.peticionPendiente = true;
      axios
        .put(
          "api/Bitacoras/Actualizar",
          {
            idBitacora: this.bitacora.idBitacora,
            idCabina: this.asistencia.idCabina,
            idUsuario: this.bitacora.idUsuario,
            operador: this.bitacora.operador,
            fechaHoraActual: this.asistencia.fechaHoraActual,
            comDireccionSiniestro: this.asistencia.comDireccionSiniestro,
            tipoServicio: this.asistencia.tipoServicio,
            proveedor: this.asistencia.proveedor,
            atiende: "",
            fechaHoraAsignacion: this.asistencia.fechaHoraAsignacion,
            seguimiento: null,
            fechaHoraContacto: this.asistencia.fechaHoraContacto,
            fechaHoraCierreAsistencia:
              this.asistencia.fechaHoraCierreAsistencia,
            obsAdicionales: this.asistencia.obsAdicionales,
            fechaActualizacion: this.getFechaHora(),
            estatusAsistencia: this.asistencia.estatusAsistencia,
          },
          configuracion
        )
        .then((res) => {
          const existeNuevaBitacora =
            this.seguimientosSeparados.length >
            this.bitacora.detalleBitacora.length;

          if (existeNuevaBitacora) this.agregarDetalleBitacora();
        })
        .catch((err) => {
          this.snackColor = "error";
          this.snackText = "¡No se pudo actualizar la Bitácora!";
          this.snack = true;

          console.error(err.response);
        })
        .finally(() => {
          this.peticionPendiente = false;
        });
    },
    agregarDetalleBitacora() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      const detalle =
        this.seguimientosSeparados[this.seguimientosSeparados.length - 1];

      const lastDetalle = detalle.seguimiento.replace(
        this.seguimientoFechaUsuario,
        ""
      );

      axios
        .post(
          "api/DetalleBitacora",
          {
            bitacoraId: this.bitacora.idBitacora,
            detalle: lastDetalle,
            tipoDetalleBitacoraId: detalle.tipoDetalleBitacoraId,
          },
          configuracion
        )
        .then((res) => {
          this.snackText = "¡Bitácora guardada correctamente!";
          this.snackColor = "primary";
          this.snack = true;

          // this.close();
          this.selectedTab = null;
          this.tabBitacora = null;
          this.tipoDetalleBitacoraId = 1;

          this.listarBitacoras();
        })
        .catch((err) => console.error(err.response));
    },
    actualizarBitacora() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.peticionPendiente) return;
      this.peticionPendiente = true;

      let seguimientosLegacy = this.seguimientosSeparados
        .map((segSeparado) => segSeparado.seguimiento)
        .join("");

      if (seguimientosLegacy.length > this.caracteresDisponibles) {
        this.snackColor = "error";
        this.snackText = `Se sobrepasó el límite de caracteres disponibles ${seguimientosLegacy.length}/${this.caracteresDisponibles}`;
        this.snack = true;

        return;
      }

      axios
        .put(
          "api/Bitacoras/Actualizar",
          {
            idBitacora: this.bitacora.idBitacora,
            idCabina: this.asistencia.idCabina,
            idUsuario: this.bitacora.idUsuario,
            operador: this.bitacora.operador,
            fechaHoraActual: this.asistencia.fechaHoraActual,
            comDireccionSiniestro: this.asistencia.comDireccionSiniestro,
            tipoServicio: this.asistencia.tipoServicio,
            proveedor: this.asistencia.proveedor,
            atiende: "",
            fechaHoraAsignacion: this.asistencia.fechaHoraAsignacion,
            seguimiento: seguimientosLegacy,
            fechaHoraContacto: this.asistencia.fechaHoraContacto,
            fechaHoraCierreAsistencia:
              this.asistencia.fechaHoraCierreAsistencia,
            obsAdicionales: this.asistencia.obsAdicionales,
            fechaActualizacion: this.getFechaHora(),
            estatusAsistencia: this.asistencia.estatusAsistencia,
          },
          configuracion
        )
        .then((res) => {
          this.snackColor = "primary";
          this.snackText = "¡Bitácora Actualizada!";
          this.snack = true;

          this.close();
        })
        .catch((err) => {
          this.snackColor = "error";
          this.snackText = "¡No se pudo actualizar la Bitácora!";
          this.snack = true;

          console.error(err.response);
        })
        .finally(() => {
          this.peticionPendiente = false;
        });
    },
    listarBitacoras() {
      this.banderaFechaNombreBitacora = false;
      this.disabledActualizarBitacora = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/Bitacoras/${this.numeroAsistencia}/NumeroAsistencia`,
          configuracion
        )
        .then((res) => {
          this.asistencia = res.data.asistencia;
          this.bitacora = res.data.bitacora;

          this.seguimientosSeparados = [];
          if (this.bitacora.seguimiento) {
            this.splitSeguimiento();
            this.enableLegacySupport = true;
          } else {
            this.enableLegacySupport = false;

            this.seguimientosSeparados = res.data.bitacora.detalleBitacora.map(
              (db) => {
                return {
                  seguimiento: `${db.detalle} ${db.fechaHora.replace(
                    "T",
                    " "
                  )} ${db.usuario}~`,
                  disabled: true,
                  tipoDetalleBitacoraId: db.tipoDetalleBitacoraId,
                };
              }
            );
          }
        })
        .catch((err) => {
          this.snackText = "¡No se encontraron bitácoras para la asistencia!";
          this.snackColor = "error";
          this.snack = true;

          console.error(err.response);
        })
        .finally(() => (this.loader = false));
    },
    splitSeguimiento() {
      const separados = this.bitacora.seguimiento.split("~");
      separados.forEach((element, index) => {
        this.seguimientosSeparados.push({
          seguimiento: element + "~",
          disabled: true,
        });
      });
    },
  },
};
</script>

<style></style>
